import { WindTurbines } from "./WindTurbines";
export default WindTurbines;
